import { TransitionType, supportsDirection } from './transition-drag-data';

export interface TransitionPreset {
  type: TransitionType;
  name: string;
  supportsDirection: boolean;
}

export const TRANSITION_PRESETS: TransitionPreset[] = [
  {
    type: 'fade',
    name: 'Fade',
    supportsDirection: supportsDirection('fade'),
  },
  {
    type: 'slide',
    name: 'Slide',
    supportsDirection: supportsDirection('slide'),
  },
  {
    type: 'wipe',
    name: 'Wipe',
    supportsDirection: supportsDirection('wipe'),
  },
  {
    type: 'flip',
    name: 'Flip',
    supportsDirection: supportsDirection('flip'),
  },
  {
    type: 'clockWipe',
    name: 'ClockWipe',
    supportsDirection: supportsDirection('clockWipe'),
  },
  {
    type: 'iris',
    name: 'Iris',
    supportsDirection: supportsDirection('iris'),
  },
];
